import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export function validateEmail() {
  return (control: AbstractControl) => {
    const pattern =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const namePatternRegx = new RegExp(pattern);
    if (!control.value) {
      return undefined;
    }
    return Validators.pattern(namePatternRegx)(control);
  };
}

export function validateName() {
  return (control: AbstractControl) => {
    const pinPatternRegx = new RegExp('^[_.@A-Za-z0-9-]*$');
    if (!control.value) {
      return undefined;
    }
    return Validators.pattern(pinPatternRegx)(control);
  };
}

export function validatePassword() {
  return (control: AbstractControl) => {
    const pinPatternRegx = new RegExp('^.{4,}$');
    if (!control.value) {
      return undefined;
    }
    return Validators.pattern(pinPatternRegx)(control);
  };
}

export function validatePhone() {
  return (control: AbstractControl) => {
    const phonePatternRegx = new RegExp('^[0-9+()-]{10,15}$');
    if (!control.value) {
      return undefined;
    }
    return Validators.pattern(phonePatternRegx)(control);
  };
}

export function validateTime() {
  return (control: AbstractControl) => {
    if (!control.value) {
      return undefined;
    }
    const regX = new RegExp('^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$');
    if (!regX.test(control.value)) {
      return { time: true };
    }
    return undefined;
  };
}

export function validateAutoCompleteId() {
  return (control: AbstractControl) => {
    if (!control.value) {
      return undefined;
    }
    if (!control.value.id) {
      return { wrongId: true };
    }
    return undefined;
  };
}

export const mustMatch: ValidatorFn = (formGroup: UntypedFormGroup): ValidationErrors | null => {
  const password = formGroup.get('newPassword');
  const passwordRepeat = formGroup.get('newPasswordRepeat');

  if (passwordRepeat.errors && !passwordRepeat.errors.mustMatch) {
    return;
  }

  if (password.value !== passwordRepeat.value) {
    passwordRepeat.setErrors({ mustMatch: true });
  } else {
    passwordRepeat.setErrors(null);
  }
};
